import shahariar_rijon_resume from '../assets/pdf/Shahariar Rijon Resume.pdf'

export const headerData = {
    name: 'Shahariar Rijon',
    title: "Web Developer",
    desciption: "A passionate individual who always thrive to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
    image: 'https://1.bp.blogspot.com/-bmon56iESYY/YOKPPEk4mII/AAAAAAAAF9o/CtbLigaPf5gQyFjB6biStXczwrwLT7dwACLcBGAsYHQ/s432/RijonAuthorProfile.png',
    resumePdf: shahariar_rijon_resume
}
